

// // LanguageLayout.jsx
// import { useEffect } from "react";
// import { useParams, Outlet } from "react-router-dom";
// import { useTranslation } from "react-i18next";

// const LanguageLayout = () => {
//   const { lang } = useParams(); // grabs :lang from URL
//   const { i18n } = useTranslation();

//   useEffect(() => {
//     // Only change language if it's different
//     if (lang && i18n.language !== lang) {
//       i18n.changeLanguage(lang);
//     }
//   }, [lang, i18n]);

//   return <Outlet />; // renders the page components
// };

// export default LanguageLayout;

import { Outlet, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

const LanguageLayout = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default LanguageLayout;